module.exports={
  "timezones": {
    "Etc/GMT+12": true,
    "Pacific/Midway": true,
    "US/Hawaii": true,
    "US/Alaska": true,
    "US/Pacific": true,
    "US/Arizona": true,
    "America/Chihuahua": true,
    "US/Mountain": true,
    "America/Guatemala": true,
    "US/Central": true,
    "Chile/EasterIsland": true,
    "America/Mexico_City": true,
    "Canada/Saskatchewan": true,
    "America/Bogota": true,
    "US/Eastern": true,
    "America/Caracas": true,
    "America/Asuncion": true,
    "Canada/Atlantic": true,
    "America/Cuiaba": true,
    "America/Manaus": true,
    "America/Santiago": true,
    "Canada/Newfoundland": true,
    "America/Bahia": true,
    "America/Buenos_Aires": true,
    "America/Cayenne": true,
    "America/Godthab": true,
    "America/Montevideo": true,
    "Etc/GMT+2": true,
    "Atlantic/Cape_Verde": true,
    "Atlantic/Azores": true,
    "Africa/Casablanca": true,
    "Greenwich": true,
    "Universal": true,
    "Africa/Monrovia": true,
    "Europe/Dublin": true,
    "Europe/Amsterdam": true,
    "Europe/Belgrade": true,
    "Europe/Brussels": true,
    "Europe/Sarajevo": true,
    "Africa/Luanda": true,
    "Africa/Windhoek": true,
    "Asia/Amman": true,
    "Europe/Athens": true,
    "Asia/Beirut": true,
    "Africa/Cairo": true,
    "Asia/Damascus": true,
    "Africa/Harare": true,
    "Europe/Helsinki": true,
    "Europe/Istanbul": true,
    "Asia/Jerusalem": true,
    "Europe/Kaliningrad": true,
    "Africa/Tripoli": true,
    "Europe/Astrakhan": true,
    "Asia/Baghdad": true,
    "Asia/Kuwait": true,
    "Europe/Minsk": true,
    "Europe/Moscow": true,
    "Africa/Nairobi": true,
    "Asia/Tehran": true,
    "Asia/Muscat": true,
    "Asia/Baku": true,
    "Europe/Samara": true,
    "Indian/Mauritius": true,
    "Asia/Tbilisi": true,
    "Asia/Yerevan": true,
    "Asia/Kabul": true,
    "Asia/Ashgabat": true,
    "Asia/Yekaterinburg": true,
    "Asia/Karachi": true,
    "Asia/Kolkata": true,
    "Asia/Kathmandu": true,
    "Asia/Barnaul": true,
    "Asia/Dhaka": true,
    "Asia/Novosibirsk": true,
    "Asia/Yangon": true,
    "Asia/Bangkok": true,
    "Asia/Krasnoyarsk": true,
    "Asia/Chongqing": true,
    "Asia/Chita": true,
    "Asia/Irkutsk": true,
    "Asia/Kuala_Lumpur": true,
    "Australia/Perth": true,
    "Asia/Taipei": true,
    "Asia/Ulaanbaatar": true,
    "Asia/Pyongyang": true,
    "Asia/Tokyo": true,
    "Asia/Seoul": true,
    "Asia/Yakutsk": true,
    "Australia/Adelaide": true,
    "Australia/Darwin": true,
    "Australia/Brisbane": true,
    "Australia/Sydney": true,
    "Pacific/Guam": true,
    "Australia/Hobart": true,
    "Asia/Magadan": true,
    "Asia/Sakhalin": true,
    "Asia/Vladivostok": true,
    "Asia/Srednekolymsk": true,
    "Pacific/Guadalcanal": true,
    "Asia/Anadyr": true,
    "Pacific/Auckland": true,
    "Etc/GMT-12": true,
    "Pacific/Fiji": true,
    "Pacific/Tongatapu": true,
    "Pacific/Kiritimati": true,
    "Israel": true
  }
}